import { forwardRef, useImperativeHandle } from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import '../../views/ServiceReport.css';
import '../forms/Button.css';
import { getLocalizedDateTime } from '../../localization/LocalizedString';
import addTimes from './TimeAddition';

const ExportInstallationDocumentExcelButton = forwardRef(({ currentLanguage, translate, data }, ref) => {
  const download = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    // Header row
    worksheet.addRow([
      translate('service_report.column_task.user'),
      translate('service_report.column_task.employeeId'),
      translate('service_report.column_task.date'),
      translate('service_report.column_task.customer'),
      translate('service_report.column_task.consignorName'),
      translate('service_report.column_task.terminal'),
      translate('service_report.column_task.end_customer'),
      translate('service_report.column_task.address'),
      translate('service_report.column_task.deviceName'),
      translate('service_report.column_task.shipmentId'),
      translate('service_report.column_task.duration'),
    ]);

    // Data rows
    let overallSeconds = 0;
    data.forEach((item) => {
      overallSeconds = addTimes(overallSeconds, item.task?.duration);

      worksheet.addRow([
        item.user || '',
        item.employeeId || '',
        item.date ? getLocalizedDateTime(new Date(item.date), currentLanguage) : '',
        item.businessCustomer || '',
        item.orderData?.consignorName || '',
        item.companyName || '',
        item.endCustomer?.name || '',
        item.endCustomer?.place || '',
        currentLanguage === 'fi' ? item.device?.deviceNamesFi : item.device?.deviceNamesEn,
        item.device?.shipmentIds || '',
        item.task?.duration || '',
      ]);
    });

    // Add total row
    worksheet.addRow([
      '', '', '', '', '', '', '', '', '', '', overallSeconds,
    ]);

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `${translate('service_report.search.type_installationDocument')}.xlsx`);
  };

  useImperativeHandle(ref, () => ({
    download,
  }));

  return null;
});

export default ExportInstallationDocumentExcelButton;
